import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { ThoughtLeader } from "../../../../stores/CoursePreviewStore/Types";

interface Props {
  leader: ThoughtLeader;
}

interface State {
  showModal: boolean;
}

const stripHtml = (html: string = "") =>
  html
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&rsquo;|&#39;/g, "'")
    .replace(/&ldquo;|&rdquo;|&quot;/g, '"')
    .replace(/\s+/g, " ")
    .trim();

class Leader extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickShowModal = (e, val: boolean) => {
    e.preventDefault();
    this.setState({ showModal: val });
  };

  render() {
    const { leader } = this.props;
    const { showModal } = this.state;
    const biography = stripHtml(leader.formatted_biography);
    // An organisation has no title; its name is the whole story.
    const role = leader.job_title || null;
    // People with a page of their own get the whole card as a link to it;
    // the bio pop-up stays for those without one.
    const hasProfile = Boolean(leader.profile_path);
    const hasLongBiography = !hasProfile && biography.length > 170;
    const bioPreview =
      biography.length > 220
        ? `${biography.slice(0, 220).trim()}...`
        : biography;

    return (
      <>
        <article
          className={`tutor-card${hasLongBiography ? " bio-overflow" : ""}${
            hasProfile ? " has-profile" : ""
          }`}
          role="listitem"
        >
          {hasProfile && (
            <a
              href={leader.profile_path}
              target="_blank"
              rel="noopener"
              className="tutor-card-link"
              aria-label={`${leader.name}: open their page in a new tab`}
            />
          )}
          <div className="tutor-photo">
            <img
              src={leader.picture_url}
              alt={`Portrait of ${leader.name}`}
              loading="lazy"
              width="240"
              height="240"
              decoding="async"
            />
          </div>
          <div className="tutor-body">
            <h3 className="tutor-name">{leader.name}</h3>
            {role && <div className="tutor-role">{role}</div>}
            <p className="tutor-bio">{bioPreview}</p>
            <div className="tutor-full-bio" hidden>
              {/* @ts-ignore */}
              {ReactHtmlParser(leader.formatted_biography)}
            </div>
            {hasLongBiography && (
              <button
                type="button"
                className="tutor-readmore"
                onClick={(e) => this.onClickShowModal(e, true)}
              >
                Read full bio
              </button>
            )}
            <div className="tutor-links" aria-label={`${leader.name} online`}>
              {leader.linkedin_url && (
                <a
                  href={leader.linkedin_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${leader.name} on LinkedIn`}
                >
                  <svg aria-hidden="true">
                    <use href="#ic-li" />
                  </svg>
                </a>
              )}
              {leader.twitter_url && (
                <a
                  href={leader.twitter_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${leader.name} on Twitter`}
                >
                  <svg aria-hidden="true">
                    <use href="#ic-twit" />
                  </svg>
                </a>
              )}
              {leader.website_url && (
                <a
                  href={leader.website_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${leader.name} website`}
                >
                  <svg aria-hidden="true">
                    <use href="#ic-link" />
                  </svg>
                </a>
              )}
            </div>
          </div>
        </article>

        {showModal && (
          <div
            className="content-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby={`tutor-modal-title-${leader.id}`}
            aria-hidden="false"
          >
            <button
              type="button"
              className="content-modal-backdrop"
              aria-label="Close"
              onClick={(e) => this.onClickShowModal(e, false)}
            />
            <div className="content-modal-panel" role="document">
              <button
                type="button"
                className="content-modal-close"
                aria-label="Close"
                onClick={(e) => this.onClickShowModal(e, false)}
              >
                ×
              </button>
              <header className="content-modal-header">
                {role && <p className="content-modal-eyebrow">{role}</p>}
                <h2
                  className="content-modal-title"
                  id={`tutor-modal-title-${leader.id}`}
                >
                  {leader.name}
                </h2>
              </header>
              <div className="content-modal-body">
                {/* @ts-ignore */}
                {ReactHtmlParser(leader.formatted_biography)}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default Leader;
